import * as React from "react";
import { cn } from "../lib/utils";
import { Card } from "../primitive/card";

export function PanelCard({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <Card
      className={cn(
        // Preserve Fluentry's elevated glass surface here so upstream shadcn primitives can stay close to nova defaults.
        "border-border/70 bg-card/88 shadow-lg shadow-primary/5 backdrop-blur-sm supports-[backdrop-filter]:bg-card/82",
        className,
      )}
      {...props}
    />
  );
}
